/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-colorizer',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoColorizerComponent extends NestedOption {
    @Input()
    get colorCodeField(): string {
        return this._getOption('colorCodeField');
    }
    set colorCodeField(value: string) {
        this._setOption('colorCodeField', value);
    }

    @Input()
    get colorizeGroups(): boolean {
        return this._getOption('colorizeGroups');
    }
    set colorizeGroups(value: boolean) {
        this._setOption('colorizeGroups', value);
    }

    @Input()
    get palette(): string | Array<string> {
        return this._getOption('palette');
    }
    set palette(value: string | Array<string>) {
        this._setOption('palette', value);
    }

    @Input()
    get paletteExtensionMode(): string {
        return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value: string) {
        this._setOption('paletteExtensionMode', value);
    }

    @Input()
    get range(): Array<number> {
        return this._getOption('range');
    }
    set range(value: Array<number>) {
        this._setOption('range', value);
    }

    @Input()
    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }


    protected get _optionPath() {
        return 'colorizer';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoColorizerComponent
  ],
  exports: [
    DxoColorizerComponent
  ],
})
export class DxoColorizerModule { }
